export default __webpack_public_path__ + "static/media/section2-img3.2d3b1482.png";